$('.video-lightbox__trigger').click(function () {
	if ($('.' + $(this).attr('id')).hasClass('active')) {
		hideVideo();
	} else {
		showVideo(this);
	}
});
$('.video-lightbox__close').click(function () {
	hideVideo();
});

/**
 * If click outside video
 */
$(document).on('click', '.video-lightbox__lightbox.active', function (e) {
	let target = $( e.target );
	if (target.is($(this))) {
		hideVideo();
	}
});

function showVideo(trigger) {
	let parent = $('.' + $(trigger).attr('id'));
	let videoType = parent.data('type')

	$('body').addClass('no-scroll').append(parent)
	parent.addClass('active');

	if (videoType === 'oembed') {
		let video = parent.find('iframe')[0];
		let src = video.src;
		video.src = '';
		video.src = src+ '&autoplay=1&rel=0';
	} else {
		let video = parent.find('video')[0]
		video.currentTime = 0;
		video.play()
		video.addEventListener('webkitendfullscreen', function () {
			videoExitedFullscreen(video);
		}, false);
	}
	$(document).on('keyup', function (e) {
		if (e.keyCode === 27) {
			hideVideo();
		}
	});
}

function hideVideo() {
	$('body').removeClass('no-scroll')
	$('.video-lightbox__lightbox').each(function () {
		let videoType = $(this).data('type')
		$(this).removeClass('active');

		if (videoType === 'oembed') {
			let video = $(this).find('iframe')[0];
			let src = video.src;
			video.src = '';
			video.src = src.replace('&autoplay=1', '').replace('&rel=0', '');
		} else {
			let video = $(this).find('video')[0];
			video.pause();
		}
	});
}

function videoExitedFullscreen() {
	if (!document.fullScreenElement && !document.webkitIsFullScreen === true && !document.mozFullScreen && !document.msFullscreenElement) {
		hideVideo()
	}
}